<template>
  <span :class="'rating d-flex d-flex_middle ' + ratingClass">
    <span class="d-flex d-flex_reverse d-flex_middle">
      <span
        v-for="n in 5"
        :key="n"
        :class="[
          {
            'is-active': n === ratingPosition,
          },
          'rating__button ' + iconClass,
        ]"
      >
        <Icon iconName="icon-star" className="icon-full" />
      </span>
    </span>

    <span :class="'d-block ' + textClass" v-if="showNumber">
      {{ this.ratingCount }} {{ ratingTotalString }}
    </span>
  </span>
</template>

<script>
import Icon from "../Icon/Icon.vue";

export default {
  name: "Rating",
  components: {
    Icon,
  },
  props: {
    showNumber: {
      type: Boolean,
      default: false,
    },
    ratingCount: {
      type: Number,
      default: 4,
    },
    ratingTotal: {
      type: Number,
      default: 5,
    },
    ratingTotalString: {
      type: String,
      default: "",
    },
    ratingClass: {
      type: String,
      default: "",
    },
    iconClass: {
      type: String,
      default: "rating__button_sm",
    },
    textClass: {
      type: String,
      default: "text-grey-strong fs-14 ml-8 ml-sm-4",
    },
  },
  computed: {
    ratingPosition() {
      return this.ratingTotal - this.ratingRounded + 1;
    },
    ratingRounded() {
      return Math.round(this.ratingCount);
    },
  },
};
</script>

<style lang="scss">
@import "./rating.scss";
</style>
